import api from './api';

// CPD + QMS API Client
export const cpdAPI = {
  // CPD Records
  createRecord: (data) => api.post('/api/cpd/records', data),
  listRecords: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.staff_id) queryParams.append('staff_id', params.staff_id);
    if (params.cpd_year) queryParams.append('cpd_year', params.cpd_year);
    return api.get(`/api/cpd/records?${queryParams.toString()}`);
  },
  getCompetency: (staffId) => api.get(`/api/cpd/competency/${staffId}`),
  
  // Engagements
  createEngagement: (data) => api.post('/api/engagements', data),
  listEngagements: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.risk_score) queryParams.append('risk_score', params.risk_score);
    return api.get(`/api/engagements?${queryParams.toString()}`);
  },
  
  // QMS
  getQMSDashboard: () => api.get('/api/qms/dashboard')
};